import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Transition } from '@headlessui/react';

const FadeIn = ({ children }) => {
  const [displayed, setDisplayed] = useState(false)

  useEffect(() => {
    const displayInterval = setInterval(() => {
      setDisplayed(true)
    }, 50);

    return () => {
      clearInterval(displayInterval);
    };
  }, []);

  return (
    <Transition
      as={Fragment}
      show={displayed}
      enter='vesta-fade-in'
      enterFrom='vesta-opacity-0'
      enterTo='vesta-opacity-100'
    >
      <div>
        {children}
      </div>
    </Transition>
  )
}

// PropTypes
FadeIn.propTypes = {
  children: PropTypes.node.isRequired
}

export default FadeIn;
